// Chargebee is a global
import Swal from 'sweetalert2'
import { history } from '../store'
import {
  emarPriceTable,
  proPriceTableMonthly,
  familyPriceTableMonthly,
} from '@lmc/common/constants'
import { getJSON, postJSON } from '../common/services/api'
import { mixpanel, gaPageView, gaEvent } from '../common/services/analytics'
import * as types from '../common/types'
import * as GlobalOperations from './Global'
import _ from 'lodash'

export function subscribeTo(redirectUrl, planId) {
  return (dispatch, getState) => {
    postJSON({ url: `services/chargebee/subscriptions/${planId}` })
      .then(() => {
        const { home } = getState().global
        dispatch(GlobalOperations.getHomeDetails(home.id))
        if (redirectUrl) history.push(redirectUrl)
      })
      .catch((error) => {
        alert('Oops: ' + error.message || error.error)
      })

    gaPageView(`subscribe/${planId}`)
    gaEvent({
      category: 'Subscriptions',
      action: `subscribe/${planId}`,
      label: `Subscribed to ${planId}`,
    })
  }
}

export function openNewPlan({ planId, redirectUrl = `/settings/billing` }) {
  return (dispatch, getState) => {
    gaEvent({
      category: 'Subscriptions',
      action: `Open ${planId} checkout`,
    })

    // Base the plan_unit_price on the number of active residents
    // The price tables map that number to the actual price in pounds
    let priceTable
    if (planId === 'pro-monthly') priceTable = proPriceTableMonthly
    if (planId === 'e-mar') priceTable = emarPriceTable
    if (planId === 'family-monthly') priceTable = familyPriceTableMonthly

    // Get thee total count of active residents
    const state = getState()
    const activeResidents = _.filter(state.data.residents, {
      status: 'active',
    }).length

    let planUnitPrice
    if (priceTable) planUnitPrice = priceTable[activeResidents] * 100

    let url = `/api/services/chargebee/portal_session/${planId}`
    if (planUnitPrice) url += `?plan_unit_price=${planUnitPrice}`

    window.Chargebee.getInstance().openCheckout({
      hostedPage: () => getJSON({ url }),
      success: () => {
        dispatch(subscribeTo(redirectUrl, planId))
        dispatch(getSubscriptions())
        gaEvent({
          category: 'Subscriptions',
          action: `Completed ${planId} checkout`,
        })
        // CO-251: Trigger Google Analytics goal completion
        if (mixpanel)
          mixpanel.track(`CO_start_trial_${planId.replace('-', '')}`)
        gaPageView(`https://logmycare.co.uk/thank-you-for-choosing-${planId}/`)
      },
      error: (e) => {
        // show error...
        // eg. "Already another checkout is in progress"
        showErrorAlert('Something went wrong. Please contact support!')
        console.log(e)
        gaEvent({
          category: 'Subscriptions',
          action: `Error opening new ${planId} checkout`,
          label: e.message || e.error,
        })
      },
    })
  }
}

export function getSubscriptions() {
  return (dispatch) => {
    getJSON({ url: '/api/services/chargebee/subscriptions' })
      .then((res) => {
        dispatch({
          type: types.SET_CB_SUBSCRIPTION_DETAILS,
          subscriptions: res.result,
        })
      })
      .catch((e) => console.log(e))

    getJSON({ url: '/api/services/chargebee/customer' })
      .then((res) => {
        dispatch({
          type: types.SET_CB_CUSTOMER_DETAILS,
          customer: res.result,
        })
      })
      .catch((e) => console.log(e))
  }
}

export function openExistingPlan() {
  // Warning: API disabled
  return (dispatch) => {
    window.Chargebee.getInstance().openCheckout({
      hostedPage: () =>
        getJSON({ url: `/api/services/chargebee/checkout_existing` }),
      success: function () {
        // success callback.....
        gaEvent({
          category: 'Subscriptions',
          action: `Opened existing plan`,
        })
      },
      error: (e) => {
        showErrorAlert('Something went wrong. Please contact support!')
        console.log(e)
        gaEvent({
          category: 'Subscriptions',
          action: `Error opening existing plan`,
          label: e.message || e.error,
        })
      },
    })
  }
}

export function openChargebeePortal() {
  return (dispatch) => {
    const chargebeeInstance = window.Chargebee.getInstance()
    chargebeeInstance.setPortalSession(() =>
      getJSON({ url: `/api/services/chargebee/portal_session` })
    )

    chargebeeInstance.createChargebeePortal().open({
      close() {
        // console.log('createChargebeePortal.onClose')
      },
    })

    gaEvent({
      category: 'Subscriptions',
      action: `Open Chargebee Portal`,
    })
  }
}

const showErrorAlert = (msg) => {
  Swal.fire({
    title: 'Woops!',
    html: `<div style='font-weight: 400;'>${msg}</div>`,
    type: 'error',
    confirmButtonClass: 'lmc-swal-confirm-button',
  })
}
